/* global DOMParser */
document.addEventListener( 'DOMContentLoaded', function () {
	const wrappers = document.querySelectorAll( '.media-releases-wrapper' );
	if ( ! wrappers.length ) return;

	wrappers.forEach( ( wrapper ) => {
		const grid = wrapper.querySelector( '.media-grid' );
		const loadMoreBtn = wrapper.querySelector( '.load-more-btn' );
		const spinner = wrapper.querySelector( '.load-more-spinner' );

		if ( ! grid || ! loadMoreBtn || ! spinner ) return;

		const postIds = JSON.parse( wrapper.dataset.postIds || '[]' );
		const postsPerPage = 9;
		let currentPage = parseInt( grid.dataset.currentPage || '1', 10 );
		const totalPages = Math.ceil( postIds.length / postsPerPage );

		loadMoreBtn.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			if ( currentPage >= totalPages ) return;

			spinner.style.display = 'block';
			loadMoreBtn.style.display = 'none';

			currentPage++;
			const offset = ( currentPage - 1 ) * postsPerPage;
			const nextPostIds = postIds.slice( offset, offset + postsPerPage );

			// Fetch next batch of posts
			fetch( `${ window.location.pathname }?partial=media-releases&ids=${ nextPostIds.join( ',' ) }` )
				.then( ( res ) => res.text() )
				.then( ( html ) => {
					const parser = new DOMParser();
					const doc = parser.parseFromString( html, 'text/html' );
					const newCards = doc.querySelectorAll( '.media-card' );

					newCards.forEach( ( card ) => grid.appendChild( card ) );

					spinner.style.display = 'none';

					if ( currentPage < totalPages ) {
						loadMoreBtn.style.display = 'block';
					} else {
						loadMoreBtn.remove();
					}
				} )
				.catch( () => {
					spinner.style.display = 'none';
					loadMoreBtn.style.display = 'block';
				} );
		} );
	} );
} );
